/**
 * API Service pentru Investigation Types (Tipuri de investigații)
 */

import apiClient from './api';
import {
  InvestigationCategory,
  InvestigationCategoryCreate,
  InvestigationCategoryUpdate,
  InvestigationType,
  InvestigationTypeListItem,
  InvestigationTypesListResponse,
  InvestigationTypesFilters,
  InvestigationTypeCreate,
  InvestigationTypeUpdate,
} from '../types/investigationTypes';

// ============================================================
// Investigation Categories
// ============================================================

export const getInvestigationCategories = async (isActive?: boolean): Promise<InvestigationCategory[]> => {
  const params = new URLSearchParams();
  if (isActive !== undefined) params.append('isActive', String(isActive));
  
  const response = await apiClient.get(`/investigation-types/categories?${params.toString()}`);
  return response.data;
};

export const createInvestigationCategory = async (data: InvestigationCategoryCreate): Promise<InvestigationCategory> => {
  const response = await apiClient.post('/investigation-types/categories', data);
  return response.data;
};

export const updateInvestigationCategory = async (
  id: string,
  data: InvestigationCategoryUpdate
): Promise<InvestigationCategory> => {
  const response = await apiClient.patch(`/investigation-types/categories/${id}`, data);
  return response.data;
};

export const deleteInvestigationCategory = async (id: string): Promise<void> => {
  await apiClient.delete(`/investigation-types/categories/${id}`);
};

// ============================================================
// Investigation Types
// ============================================================

export const getInvestigationTypes = async (
  filters: InvestigationTypesFilters = {}
): Promise<InvestigationTypesListResponse> => {
  const params = new URLSearchParams();
  
  if (filters.categoryId) params.append('categoryId', filters.categoryId);
  if (filters.search) params.append('search', filters.search);
  if (filters.isActive !== undefined) params.append('isActive', String(filters.isActive));
  if (filters.skip !== undefined) params.append('skip', String(filters.skip));
  if (filters.limit !== undefined) params.append('limit', String(filters.limit));
  
  const response = await apiClient.get(`/investigation-types?${params.toString()}`);
  return response.data;
};

export const getInvestigationType = async (id: string): Promise<InvestigationType> => {
  const response = await apiClient.get(`/investigation-types/${id}`);
  return response.data;
};

export const createInvestigationType = async (data: InvestigationTypeCreate): Promise<InvestigationType> => {
  const response = await apiClient.post('/investigation-types', data);
  return response.data;
};

export const updateInvestigationType = async (
  id: string,
  data: InvestigationTypeUpdate
): Promise<InvestigationType> => {
  const response = await apiClient.patch(`/investigation-types/${id}`, data);
  return response.data;
};

export const deleteInvestigationType = async (id: string): Promise<void> => {
  await apiClient.delete(`/investigation-types/${id}`);
};

// Export all functions
export default {
  getInvestigationCategories,
  createInvestigationCategory,
  updateInvestigationCategory,
  deleteInvestigationCategory,
  getInvestigationTypes,
  getInvestigationType,
  createInvestigationType,
  updateInvestigationType,
  deleteInvestigationType,
};
